"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = __importDefault(require("@modules/Icon"));
require("./style.scss");
const DataSwitch = (props) => {
    const { handleClickDataSwitch, currenEditDataRowNumber, isLastEditableNo } = props;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "dataSwitch__wrapper", onClick: handleClickDataSwitch }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { id: "arrowLeft", icon: "expand", className: `arrowLeft ${(isLastEditableNo === null || isLastEditableNo === void 0 ? void 0 : isLastEditableNo.left) && 'lastEditable'}` }), (0, jsx_runtime_1.jsxs)("div", { children: ["\u7B2C ", currenEditDataRowNumber, " \u7B46"] }), (0, jsx_runtime_1.jsx)(Icon_1.default, { id: "arrowRight", icon: "expand", className: `arrowRight ${(isLastEditableNo === null || isLastEditableNo === void 0 ? void 0 : isLastEditableNo.right) && 'lastEditable'}` })] })));
};
exports.default = DataSwitch;
